package link.erpango.quip.core

import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.SharedFlow
import link.erpango.quip.data.IDataSource
import link.erpango.quip.data.remote.DResponse
import link.erpango.quip.utils.DatetimeUtils
import link.erpango.quip.utils.FileUtils

class TokenRefreshManager(private val data: IDataSource) {

    private val _sessionExpiredFlow = MutableSharedFlow<Unit>(replay = 0)
    val sessionExpiredFlow: SharedFlow<Unit> = _sessionExpiredFlow

    suspend fun tryRefreshToken(): Boolean {
        FileUtils.log("TokenRefreshManager: iniciando refresco de token")

        val currentUserId = data.db.auth.selectCurrentLoggedUserId()
        if (currentUserId == null) {
            FileUtils.log("TokenRefreshManager: no hay sesión activa, refresco cancelado")
            return false
        }

        val refreshToken = data.db.auth.selectRefreshToken(currentUserId)
        if (refreshToken.isNullOrBlank()) {
            FileUtils.log("TokenRefreshManager: refresh token vacío para usuario $currentUserId, refresco cancelado")
            return false
        }

        FileUtils.log("TokenRefreshManager: llamando a /auth/token/refresh/ para usuario $currentUserId")
        val response = data.remote.auth.refresh(refreshToken)
        return when (response) {
            is DResponse.Success -> {
                val newAccess = response.data.access ?: run {
                    FileUtils.log("TokenRefreshManager: respuesta sin access token, refresco fallido")
                    return false
                }
                val newRefresh = response.data.refresh ?: refreshToken
                data.db.auth.updateToken(
                    userId = currentUserId,
                    accessToken = newAccess,
                    refreshToken = newRefresh,
                    createdAt = DatetimeUtils.currentTimeMillis()
                )
                val nextRefreshAt = DatetimeUtils.currentTimeMillis() + 24L * 60 * 60 * 1000
                FileUtils.log("TokenRefreshManager: token refrescado correctamente para usuario $currentUserId. Próximo refresco aprox: ${DatetimeUtils.formatDateTime(nextRefreshAt)}")
                true
            }
            is DResponse.Error -> {
                FileUtils.log("TokenRefreshManager: refresco fallido — sesión expirada o token inválido (${response.error}). Emitiendo sessionExpiredFlow")
                _sessionExpiredFlow.emit(Unit)
                false
            }
            else -> {
                FileUtils.log("TokenRefreshManager: respuesta inesperada del servidor")
                false
            }
        }
    }
}
